import HttpRequest from "../http_request";

class UserApi extends HttpRequest {
  apiGetLog(id) {
    return this.fetch(`/client/v1/shipment-orders/${id}/shipment-logs`);
  }
  apiGetTimeline(id) {
    return this.fetch(`/client/v1/shipment-orders/${id}/shipment-logs`);
  }
  apiGetAccount(data) {
    return this.fetch(`/client/admin-api/v1/accounts`, {
      page: data.page,
      limit: data.limit,
      sort: data.sort,
      search: data.search
    });
  }
  apiGetOrderAll(data) {
    return this.fetch(`/client/v2/shipment-orders`,data);
  }
  apiGetOrderAllSummary(data) {
    return this.fetch(`/client/v2/shipment-orders/summary`,data);
  }
  apiGetTransection(data) {
    return this.fetch(`/client/v2/shipment-orders/summary`,data);
  }
  apiGetOrderMarkup(data) {
    return this.fetch(`/account-api/v1/shipment-orders`, data);
  }
  apiGetOrderMarkUpSelect(id) {
    return this.fetch(`/client/v2/shipment-orders/${id}`);
  }
  apiGetSelectOrderMarkup(id) {
    return this.fetch(`/account-api/v1/shipment-orders/3471`);
  }
  apiGetPickupAddresss(search) {
    return this.fetch(`/client/v1/pickup-points`,search);
  }
  apiGetBoxpackage(id) {
    return this.fetch(`/client/v1/packaging`);
  }
  apiGetPickupTransport() {
    return this.fetch(`/account-api/v1/pickup-points`);
  }
  apiGetPartnerate() {
    return this.fetch(`/client/v1/partner-rates`);
  }
  apiGetPickupOrder(data) {
    return this.fetch(`/client/v1/pickup-doc`, data);
  }
  apiGetPickupSummary(data) {
    return this.fetch(`/client/v1/pickup-doc/summary`, {
      pickup_dt: data?.pickup_dt ? data?.pickup_dt : null
    });
  }
  apiGetReceiveAddress() {
    return this.fetch(`/account-api/v1/receivers`);
  }

  apiGetTimelineOrder(id) {
    return this.fetch(`/client/v1/shipment-orders/${id}/shipment-logs`);
  }
  apiGetTimeLinePopupstepTwo(id) {
    return this.fetch(`/client/v1/shipment-orders/${id}/claims`);
  }
  apiGetClaimType() {
    return this.fetch(`/client/v1/claims/types`);
  }
  apiGetWelletTransection(id) {
    return this.fetch(`client/v1/shipment-orders/${id}/wallet-transactions`);
  }
  apiGetCommission(id) {
    return this.fetch(`/admin/v1/commission-orders/${id}/api-logs`);
  }
  apiGetPickupOrderById(id) {
    return this.fetch(`/client/v1/pickup-doc/${id}`);
  }
  apiGetPartnerList() {
    return this.fetch(`/client/v1/partners`);
  }
  apiGetCodOrder(data) {
    return this.fetch(`/client/v2/reports/shipment-orders/cod`, data);
  }
  apiGetCodOrderSummary(data) {
    return this.fetch(`/client/v2/reports/shipment-orders/cod/summary`, data);
  }
  apiGetCodOrderSummaryMoney() {
    return this.fetch(
      `/client/v1/reports/shipment-orders/cod/summary-amount`,
      data
    );
  }

  apiGetHistoryInsuranceOrder(id) {
    return this.fetch(`/client/v1/shipment-orders/${id}/wallet-service-transactions`);
  }

  apiGetdataGraph(data) {
    return this.fetch(`/client/v1/reports/shipment-orders/daily`, data);
  }
  apiGetCustomer(data) {
    return this.fetch(`/client/v1/customers`, data);
  }
  apiGetPickupOrderById(id){
    return this.fetch(`/client/v1/pickup-doc/${id}`);
  }

  apiGetPriceInsurance(data){
    return this.create(`/client/v2/shipment-orders/partner-insurance-prices`,data);
  }

  apiCreateEstimateShippingPrice(data) {
    return this.create(
      `/client/v2/shipment-orders/partner-shipping-prices`,
      data
    );
  }

  apiGetDocumentCreditNote(id){
    return this.fetch(`/client/v1/shipment-orders/${id}/documents`)
  }


  apiGetReversal(id) {
    return this.fetch(`/client/v1/shipment-orders/${id}/reversal`);
  }
  apiGetProductOnOrder(id){
    return this.fetch(`/client/v1/shipment-orders/${id}/shipment-order-items`);
  }

  apiCreateOrderNew(data) {
    return this.create(`/client/v1/shipment-orders`, data);
  }

  apiCreateOrderNewInsurance(data) {
    return this.create(`/client/v1/shipment-orders`, data);
  }



  apiCreateOrderMultiple(data) {
    return this.create(`/client/v1/shipment-orders/bulk-create`, data);
  }
  apiCreateOrderSave(data) {
    return this.create(
      `/client/v1/shipment-orders/${data.id}/claims`,
      data.formData
    );
  }
  apiCreatePickupOrder(data){
    return this.create(`/client/v1/pickup-doc/${data.partner}`,data.formData);
  }

  apiEditcancelOrder(data) {
    return this.edit(`/client/v1/shipment-orders/${data.id}/cancel`, {
      remark: data.remark
    });
  }
  apiEditupdatePickup(data) {
    return this.edit(`/client/v1/pickup-doc/flash`, { pickup_dt: data });
  }


  apiDeleteAccount(id) {
    return this.delete(`/client/v1/customers/${id}`);
  }

}

export default UserApi;
